export const UPDATE_ACCESS_TOKEN = 'UPDATE_ACCESS_TOKEN';
export const CLEAR_ACCESS_TOKEN = 'CLEAR_ACCESS_TOKEN';

export function updateAccessToken(accessToken) {
  return {
    type: UPDATE_ACCESS_TOKEN,
    accessToken,
  };
}

export function clearAccessToken() {
  return {
    type: CLEAR_ACCESS_TOKEN,
  };
}
